<template>
  <v-autocomplete
    color="primary"
    v-model="stockRoadwaySelected"
    :clearable="!unclearable"
    :items="stockRoadway"
    :loading="stockRoadwayLoading"
    :search-input.sync="stockRoadwaySearch"
    item-value="id"
    item-text="code"
    item-disabled="disabled"
    :label="noLabel ? '' : label ? label : $t('stockRoadway.ObjectName')"
    return-object
    :single-line="dense"
    :dense="dense"
    :hide-details="dense"
    :style="dense ? 'margin-left: auto; margin-right: auto' : ''"
    chips
    multiple
    deletable-chips
    small-chips
    :disabled="disabled"
  >
  </v-autocomplete>
</template>

<script>
import StockRoadways from "@/api/stock_roadways";
import Stocks from "@/api/stocks";

export default {
  name: "SearcherStockRoadways",

  props: {
    value: Array,
    stockId: Number,
    dense: Boolean,
    status: Number,
    noLabel: Boolean,
    label: String,
    unclearable: Boolean,
    disabledItems: Array,
    disabled: Boolean,
  },

  data: () => ({
    stock: [],
    stockRoadway: [],
    stockRoadwayLoading: false,
    stockRoadwaySearch: "",
    stockRoadwaySelected: [],
  }),

  methods: {
    getStockRoadwaysFromAPI() {
      //获取仓库信息
      Stocks.fetchOne(this.stockId).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock = response.data.stock;
          }
        }.bind(this)
      );
      //获取库位信息
      this.stockRoadwayLoading = true;
      StockRoadways.fetch({
        stock_ids: this.stockId,
        status: this.status,
      })
        .then(
          function (response) {
            if (response.data.status.isOK()) {
              this.stockRoadway = response.data.stock_roadways;
            }
            this.stockRoadwayLoading = false;
          }.bind(this)
        )
        .catch(
          function () {
            this.stockRoadwayLoading = false;
          }.bind(this)
        );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.stockRoadwaySelected = this.value;
      },
    },
    stockRoadwaySelected: {
      handler() {
        this.$emit("input", this.stockRoadwaySelected);
      },
    },
    stockId: {
      handler() {
        if (this.stockId) {
          this.getStockRoadwaysFromAPI();
        }        
      },
    },
  },
};
</script>